import { PatientStatsInhalerTypes } from '@/jsonapi/PatientWithStats'

function getInhalerUsagesByType(type: PatientStatsInhalerTypes) {
  return function(all: Array<{ type: PatientStatsInhalerTypes; [propName: string]: any }>) {
    return all.filter(x => x.type === type)
  }
}

export const getMaintenanceInhalerUsages = getInhalerUsagesByType(PatientStatsInhalerTypes.Maintenance)
export const getRescueInhalerUsages = getInhalerUsagesByType(PatientStatsInhalerTypes.Reliever)
